import { CompanyActivityModel } from "./company_activity.model";

export class CompanyModel {
    company_id: number;
    name: string;
    type_doc: string;
    num_doc: string;
    /** País do VAT quando type_doc = VAT (ISO2). */
    vat_country?: string | null;
    type: string;
    status: boolean;
    /** Quando true, ao marcar "Disponível" no app do motorista o atendimento é fechado (service.end).
     * Quando false, só preenche available_for_new_services_at e o atendimento segue aberto até a central finalizar. */
    auto_complete_service_on_driver_available?: boolean | null;
    /** Quando true, é obrigatório informar a viatura ao criar um turno. */
    require_ambulance_on_shift_create?: boolean | null;
    /**
     * Quando true, a empresa entra no contexto operacional do app (sidenav, plantões).
     * Quando false, é parceira só para despacho externo / pricing / repasse (sem app Prehox).
     */
    uses_prehox_app?: boolean | null;
    fantasia: string;
    IE: string;
    IM: string;
    address: string;
    /** ISO 3166-1 alpha-2 (ex.: BR, PT). */
    country?: string | null;
    /** ISO 4217 (ex.: BRL, EUR). Pré-preenchida pelo país, mas editável — não muda sozinha se o país mudar depois. */
    currency?: string | null;
    cep: string;
    city: string;
    UF: string;
    number: string;
    phone: string;
    phone_country_code?: string | null;
    email_fin: string;
    email_fat: string;
    company_size: string;
    activities: CompanyActivityModel[] = [];
    technical_manager_id: number;
    operational_manager_id: number;
    financial_manager_id: number;
    primary_color: string;
    logo: string;
    /** URL do documento AFE (Autorização de Funcionamento - ANVISA), para fornecedores. */
    afe_document?: string | null;
    company_kind?: 'manager' | 'requester' | 'provider' | 'client';
    start_date?: Date | null;
    end_date?: Date | null;
    contract_type_id?: number | null;
    timezone?: string | null;
    constructor(data?: Partial<CompanyModel>) {
        this.company_id = data?.company_id ?? null;
        this.name = data?.name ?? null;
        this.type_doc = data?.type_doc ?? null;
        this.num_doc = data?.num_doc ?? null;
        this.vat_country = data?.vat_country ?? null;
        this.type = data?.type ?? null;
        this.status = data?.status ?? null;
        this.auto_complete_service_on_driver_available = this.coerceCompanyFlag(
            data?.auto_complete_service_on_driver_available,
            true,
        );
        this.require_ambulance_on_shift_create = this.coerceCompanyFlag(
            data?.require_ambulance_on_shift_create,
            false,
        );
        this.uses_prehox_app = this.coerceCompanyFlag(data?.uses_prehox_app, true);
        this.fantasia = data?.fantasia ?? null;
        this.IE = data?.IE ?? null;
        this.IM = data?.IM ?? null;
        this.address = data?.address ?? null;
        this.country = data?.country ?? null;
        this.currency = data?.currency ?? null;
        this.cep = data?.cep ?? null;
        this.city = data?.city ?? null;
        this.UF = data?.UF ?? null;
        this.number = data?.number ?? null;
        this.phone = data?.phone ?? null;
        this.phone_country_code = data?.phone_country_code ?? '+55';
        this.email_fin = data?.email_fin ?? null;
        this.email_fat = data?.email_fat ?? null;
        this.company_size = data?.company_size ?? null;
        this.activities = data?.activities ?? [];
        this.technical_manager_id = data?.technical_manager_id ?? null;
        this.operational_manager_id = data?.operational_manager_id ?? null;
        this.financial_manager_id = data?.financial_manager_id ?? null;
        this.primary_color = data?.primary_color ?? null;
        this.logo = data?.logo ?? null;
        this.afe_document = data?.afe_document ?? null;
        this.company_kind = data?.company_kind ?? undefined;
        this.start_date = data?.start_date ? new Date(data.start_date) : null;
        this.end_date = data?.end_date ? new Date(data.end_date) : null;
        this.contract_type_id = data?.contract_type_id ?? null;
        this.timezone = data?.timezone ?? null;
    }

    /** Normaliza flags TINYINT/boolean vindas da API (`true` | `1` | `"1"`). */
    private coerceCompanyFlag(value: unknown, defaultValue: boolean): boolean {
        if (value === undefined || value === null) {
            return defaultValue;
        }
        return value === true || value === 1 || value === '1';
    }
}

export interface CnpjData {
    name: string | null;
    fantasia: string;
    IE: string;
    IM: string;
    address: string;
    cep: string;
    city: string;
    UF: string;
    number: string;
    phone: string;
    email_fin: string;
    email_fat: string;
    company_size: string;
}
